module.exports = __webpack_public_path__ + "img/77.b34d90b8.jpg";